<section>
    <div class="container" id="how-it-works">
        <h1>What makes Urlo work</h1>
        <p>
            Design it to fit your brand and voice
        </p>
        <div class="carousel">
            <a routerLink="builder"
               class="carousel-item item__1">
                <div class="item-content">
                    <h2>Customizable feedback button</h2>
                    <p>Shape the button to match your site exactly</p>
                </div>
                <div class="item-footer">
                    <span>Design your button <i class="fa fa-arrow-right"></i></span>
                </div>
            </a>
            <a class="carousel-item item__2 carousel-item-static">
                <div class="item-content">
                    <h2>Intuitive dashboard</h2>
                    <p>Review all feedback in one clear, organized place</p>
                </div>
            </a>
            <a class="carousel-item item__3 carousel-item-static">
                <div class="item-content">
                    <h2>Real-time analytics</h2>
                    <p>Watch patterns emerge as feedback comes in live</p>
                </div>
            </a>
        </div>
    </div>
</section>
